import enTrans from "./en.json";
let en = {
  translations: enTrans,
};

export default en;
